export const APP_DETAILS = {
  FA_NAME: 'فورسی',
  EN_NAME: 'Forsi',
  AR_NAME: 'فورسی',
  TJ_NAME: 'Forsi',
  FA_DESCRIPTION: 'فورسی تی وی',
  EN_DESCRIPTION: 'Forsi TV',
  AR_DESCRIPTION: 'فورسی تی وی',
  TJ_DESCRIPTION: 'Forsi телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.forsi.tv',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'forsi.tv',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '1.5.0',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'GTM-NRPJPPSH',
  LOGIN_URL: 'https://forsi.tv/activate',
  APPS_URL: 'https://forsi.tv/app',
};
